export default __webpack_public_path__ + "static/media/image-ph-health-alarm-m@2x.d8b3d770.webp";